import { forwardRef } from "react";
import { cn } from "../cn.ts";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type = "text", ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        "flex h-11 w-full rounded-full border border-[var(--brand-border)] bg-[var(--brand-paper)] px-4 text-sm",
        "placeholder:text-[var(--brand-muted)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-rose",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...rest}
    />
  );
});
